(function(){
  'use strict';

  var clarityLauncher = document.getElementById('HitchClarityLauncher');
  var chatLauncher = document.getElementById('HitchChatLauncher');
  if(!clarityLauncher && !chatLauncher) return;

  var clarityButton = null;
  var chatActivator = null;
  var clarityRoot = null;
  var chatRoot = null;
  var chatHost = null;
  var chatRuntimeRoot = null;
  var chatStateTimer = null;
  var chatClosedByHitch = false;
  var scheduled = false;

  function lockChatButtonBaseColors(){
    if(!chatLauncher) return;
    chatLauncher.style.setProperty('border-color','var(--hitch-line)','important');
    chatLauncher.style.setProperty('background','#fff','important');
    chatLauncher.style.setProperty('color','var(--hitch-ink)','important');
  }

  lockChatButtonBaseColors();

  function installShadowStyle(root,id,css){
    if(!root) return;
    var style = root.querySelector('#' + id);
    if(style) return;
    style = document.createElement('style');
    style.id = id;
    style.textContent = css;
    root.appendChild(style);
  }

  function concealOriginal(control){
    if(!control) return;
    control.style.setProperty('visibility','hidden','important');
    control.style.setProperty('opacity','0','important');
    control.style.setProperty('pointer-events','none','important');
  }

  function monitorChatState(){
    if(chatStateTimer) return;
    chatStateTimer = window.setTimeout(function(){
      chatStateTimer = null;
      connectChat();
    },150);
  }

  function getChatRuntime(host){
    var root = host && host.shadowRoot;
    return root && root.querySelector('.agent-shell__runtime');
  }

  function isChatOpen(host){
    var runtime = getChatRuntime(host);
    var runtimeRoot = runtime && runtime.shadowRoot;
    var runtimeActivator = runtimeRoot && runtimeRoot.querySelector('[part~="activator"]');
    var dialog = runtimeRoot && runtimeRoot.querySelector('[part~="dialog"]');
    if(runtimeActivator && runtimeActivator.hasAttribute('aria-expanded')){
      return runtimeActivator.getAttribute('aria-expanded') === 'true';
    }
    if(dialog) return !dialog.hasAttribute('inert');
    if(runtime && typeof runtime.open === 'boolean') return runtime.open;
    return Boolean(host && host.open);
  }

  function connectClarity(){
    var host = document.getElementById('ads-agent-host');
    var root = host && host.shadowRoot;
    if(root && root !== clarityRoot && 'MutationObserver' in window){
      clarityRoot = root;
      new MutationObserver(scheduleConnect).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded']});
    }
    if(root){
      installShadowStyle(
        root,
        'HitchClarityEntrypointOverride',
        '[data-testid="entrypoint"],[role="button"][aria-label="AI assistant"],[aria-label="Shopping Agent"] [role="button"]{' +
          'display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;' +
        '}' +
        '[data-testid="floating-view"],[data-testid="bottom-sheet-view"]{' +
          'position:fixed!important;top:50%!important;right:auto!important;bottom:auto!important;left:50%!important;' +
          'width:min(480px,calc(100vw - 24px))!important;height:min(720px,calc(100dvh - 24px))!important;' +
          'max-height:calc(100dvh - 24px)!important;margin:0!important;' +
          'transform:translate(-50%,-50%)!important;transform-origin:center center!important;' +
          'border-radius:24px!important;overflow:hidden!important;touch-action:auto!important;' +
        '}' +
        '[data-testid="bottom-sheet-view"]>div:nth-child(2){padding-bottom:0!important;}' +
        '[data-testid="bottom-sheet-view"]>div:nth-child(3){position:relative!important;right:auto!important;bottom:auto!important;left:auto!important;transform:none!important;}' +
        '@media(max-width:520px){' +
          '[data-testid="floating-view"],[data-testid="bottom-sheet-view"]{' +
            'width:calc(100vw - 16px)!important;height:calc(100dvh - 16px)!important;max-height:calc(100dvh - 16px)!important;border-radius:18px!important;' +
          '}' +
        '}'
      );
    }
    var entrypoint = root && root.querySelector('[data-testid="entrypoint"]');
    var button = entrypoint && entrypoint.matches('[role="button"]')
      ? entrypoint
      : entrypoint && entrypoint.querySelector('[role="button"]');
    if(!button && root){
      button = root.querySelector(
        '[role="button"][aria-label="AI assistant"], [aria-label="Shopping Agent"] [role="button"]'
      );
    }
    if(!button) return;
    clarityButton = button;
    concealOriginal(button);
    if(clarityLauncher){
      clarityLauncher.hidden = false;
      var expanded = !!root.querySelector('[role="dialog"][aria-modal="true"]');
      clarityLauncher.setAttribute('aria-expanded',expanded ? 'true' : 'false');
    }
  }

  function connectChat(){
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    if(host && host !== chatHost && 'MutationObserver' in window){
      chatHost = host;
      new MutationObserver(scheduleConnect).observe(host,{attributes:true,attributeFilter:['open','view','shell-ready']});
    }
    if(root && root !== chatRoot && 'MutationObserver' in window){
      chatRoot = root;
      new MutationObserver(scheduleConnect).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','open']});
      root.addEventListener('shopify-chat:close',function(){
        chatClosedByHitch = true;
        if(chatStateTimer){
          window.clearTimeout(chatStateTimer);
          chatStateTimer = null;
        }
        if(chatLauncher) chatLauncher.setAttribute('aria-expanded','false');
      });
    }
    var runtime = getChatRuntime(host);
    var runtimeRoot = runtime && runtime.shadowRoot;
    if(runtimeRoot && runtimeRoot !== chatRuntimeRoot && 'MutationObserver' in window){
      chatRuntimeRoot = runtimeRoot;
      new MutationObserver(scheduleConnect).observe(runtimeRoot,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','open','inert']});
    }
    if(root){
      installShadowStyle(
        root,
        'HitchShopifyChatActivatorOverride',
        '[part~="activator"]{' +
          'display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;' +
        '}' +
        '[part~="dialog"]{' +
          'position:fixed!important;top:50%!important;right:auto!important;bottom:auto!important;left:50%!important;' +
          'width:min(480px,calc(100dvw - 24px))!important;height:min(720px,calc(100dvh - 24px))!important;' +
          'max-width:calc(100dvw - 24px)!important;max-height:calc(100dvh - 24px)!important;margin:0!important;padding-bottom:0!important;' +
          'transform:translate(-50%,-50%)!important;transform-origin:center center!important;border-radius:24px!important;' +
        '}' +
        '@media(max-width:520px){' +
          '[part~="dialog"]{' +
            'width:calc(100dvw - 16px)!important;height:calc(100dvh - 16px)!important;' +
            'max-width:calc(100dvw - 16px)!important;max-height:calc(100dvh - 16px)!important;border-radius:18px!important;' +
          '}' +
        '}'
      );
    }
    var activator = runtimeRoot && runtimeRoot.querySelector('[part~="activator"]');
    if(!activator) activator = root && root.querySelector('[part~="activator"]');
    if(activator){
      chatActivator = activator;
      concealOriginal(activator);
    }
    if(chatLauncher){
      chatLauncher.hidden = false;
      var expanded = !chatClosedByHitch && isChatOpen(host);
      chatLauncher.setAttribute('aria-expanded',expanded ? 'true' : 'false');
      if(expanded) monitorChatState();
    }
  }

  function connect(){
    scheduled = false;
    connectClarity();
    connectChat();
  }

  function scheduleConnect(){
    if(scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(connect);
  }

  if(clarityLauncher){
    clarityLauncher.addEventListener('click',function(){
      connectClarity();
      if(clarityButton) clarityButton.click();
      window.setTimeout(scheduleConnect,50);
      window.setTimeout(scheduleConnect,300);
    });
  }

  if(chatLauncher){
    chatLauncher.addEventListener('click',function(){
      connectChat();
      var host = document.querySelector('shopify-chat');
      if(host && typeof host.show === 'function'){
        if(!chatClosedByHitch && isChatOpen(host) && typeof host.close === 'function'){
          chatClosedByHitch = true;
          host.close();
        }else{
          chatClosedByHitch = false;
          host.show();
        }
      }else{
        var currentActivator = host && host.shadowRoot && host.shadowRoot.querySelector('[part~="activator"]');
        chatActivator = currentActivator || chatActivator;
        if(chatActivator) chatActivator.click();
      }
      window.setTimeout(scheduleConnect,50);
      window.setTimeout(scheduleConnect,300);
    });
  }

  if('MutationObserver' in window){
    new MutationObserver(scheduleConnect).observe(document.documentElement,{childList:true,subtree:true});
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',scheduleConnect,{once:true});
  }else{
    scheduleConnect();
  }
  window.addEventListener('load',scheduleConnect,{once:true});
  window.setTimeout(scheduleConnect,500);
  window.setTimeout(scheduleConnect,1500);
  window.setTimeout(scheduleConnect,3500);
})();
